import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { Locked } from '@one-thd/sui-icons';

export const PrivateListMessaging = (props) => {
  return (
    <div className="sui-mx-auto sui-w-fit sui-bg-primary sui-p-4 sui-text-center">
      <div className="sui-flex sui-items-center sui-gap-2 sui-justify-center">
        <Locked
          alt="lock-icon"
        />
        <Typography variant="h3">
          This list is private
        </Typography>
      </div>
      <Typography variant="body-base">
        Please contact list owner for access
      </Typography>
      <div className="sui-my-4">
        <Button href="/" component="a">Start Shopping</Button>
      </div>
    </div>
  );

};

PrivateListMessaging.displayName = 'ProductListPrivateListMessaging';

PrivateListMessaging.propTypes = {};

PrivateListMessaging.defaultProps = {};
